/// Message
export const RING_CENTRAL_TYPE_ACTIVE_CALL_NOTIFY = 'rc-active-call-notify';
export const RING_CENTRAL_TYPE_CALL_END_NOTIFY = 'rc-call-end-notify';
export const RING_CENTRAL_TYPE_CONNECTION_STATUS_NOTIFY = 'rc-webphone-connection-status-notify';
export const RING_CENTRAL_TYPE_LOGIN_STATUS_NOTIFY = 'rc-login-status-notify';
export const RING_CENTRAL_TYPE_NATIVE_SEND_CREDENTIAL = 'rc-native-send-credential';
export const RING_CENTRAL_TYPE_NATIVE_AUTHORIZE = 'rc-native-authorize';
export const RING_CENTRAL_TYPE_NATIVE_DISCONNECT = 'rc-native-disconnect';
export const RING_CENTRAL_TYPE_NATIVE_PHONE_CALL = 'rc-native-phone-call';
export const RING_CENTRAL_TYPE_NATIVE_SMS = 'rc-native-sms';

/// Status
export const RING_CENTRAL_TYPE_CONNECTED_STATUS = 'connectionStatus-connected';
export const RING_CENTRAL_TYPE_CONNECTING_STATUS = 'connectionStatus-connecting';
export const RING_CENTRAL_TYPE_DISCONNECTED_STATUS = 'connectionStatus-disconnected';
export const RING_CENTRAL_TYPE_RINGING_TELEPHONY_STATUS = 'Ringing';

/// Adapter
export const RING_CENTRAL_TYPE_REGISTER_SERVICE_ADAPTER = 'rc-adapter-register-third-party-service';
export const RING_CENTRAL_TYPE_NEW_CALL_ADAPTER = 'rc-adapter-new-call';
export const RING_CENTRAL_TYPE_LOGIN_ADAPTER = 'rc-adapter-login';
export const RING_CENTRAL_TYPE_LOGOUT_ADAPTER = 'rc-adapter-logout';
export const RING_CENTRAL_TYPE_NEW_SMS_ADAPTER = 'rc-adapter-new-sms';
export const RING_CENTRAL_TYPE_AUTHORIZATION_CODE_ADAPTER = 'rc-adapter-authorization-code';
export const RING_CENTRAL_TYPE_WIDGET_FRAME_ADAPTER = '#rc-widget-adapter-frame';
